import { render, staticRenderFns } from "./UnicoIntegration.vue?vue&type=template&id=0b50b720&scoped=true&"
import script from "./UnicoIntegration.vue?vue&type=script&lang=js&"
export * from "./UnicoIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50b720",
  null
  
)

export default component.exports